import ReportByRates from '../ReportByRates';
import { AUDIO_REPORT_LOADING } from './audioReportStates';

export default function AudioReport({
  generateAudioReport,
  getAudioReports,
  audioReportsData,
  audioReportsState,
  rates,
}) {
  const generateReports = (r) => r.forEach((r2) => generateAudioReport(r2.id));
  const isRateReportLoading = (rate) =>
    audioReportsState[rate.id] === AUDIO_REPORT_LOADING;
  const getRateReportLink = (rate) => audioReportsData[rate.id]?.link;
  const getRateReportName = (rate) => {
    const lastUpdated = audioReportsData[rate.id]?.updatedAt
      ? new Date(audioReportsData[rate.id]?.updatedAt).toLocaleString()
      : 'No data';
    return `${rate.shortname} - ${lastUpdated}`;
  };

  return (
    <ReportByRates
      rates={rates}
      reportName="Audio Report"
      getReports={getAudioReports}
      generateReports={generateReports}
      isRateReportLoading={isRateReportLoading}
      getRateReportLink={getRateReportLink}
      getRateReportName={getRateReportName}
    />
  );
}
